import { render } from "./SegmentedController.vue?vue&type=template&id=46a660b6&scoped=true&ts=true"
import script from "./SegmentedController.vue?vue&type=script&lang=ts"
export * from "./SegmentedController.vue?vue&type=script&lang=ts"

import "./SegmentedController.vue?vue&type=style&index=0&id=46a660b6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a660b6"]])

export default __exports__